const registerToMessagesBeforeDsLoad = () => {
    if (typeof window !== 'undefined') {
        window.dsBeforeLoadMessageBuffer = []
        window.addDsBeforeLoadMessage = event => window.dsBeforeLoadMessageBuffer.push(event)
        window.addEventListener('message', window.addDsBeforeLoadMessage, false)
    }
}

export {registerToMessagesBeforeDsLoad}
